const API_BASE = "https://api.wealthcompounders.tech";
const INTERNAL_API_KEY = "fKVFY41BrQAB6a444kQy7IZA3u9NgcXo";

/**
 * @param {{ fullName: string, email: string, phone: string, module: string, internalComments?: string }} payload
 */
export async function submitWebLead(payload) {
  const url = `${API_BASE}/api/webLeads`;

  const body = {
    fullName: payload.fullName,
    email: payload.email,
    phone: payload.phone,
    module: payload.module,
    internalComments: payload.internalComments ?? "",
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-internal-key": INTERNAL_API_KEY,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let message = "Unable to submit your request. Please try again.";
    try {
      const data = await response.json();
      message = data.message || data.error || message;
    } catch {
      /* use default message */
    }
    throw new Error(message);
  }

  try {
    return await response.json();
  } catch {
    return null;
  }
}
